import React from 'react'
import { Elements, useStripe, useElements } from '@stripe/react-stripe-js'

import stripeAppearance from 'src/utils/stripeAppearance'

const StripeInner = ({ App, ...props }) => {
  const stripe = useStripe()
  const elements = useElements()

  return stripe ? <App {...props} stripe={stripe} elements={elements} /> : null
}

const StripeOuter = ({ stripePromise, stripeFonts, ...props }) =>
  <Elements
    stripe={stripePromise}
    options={{
      locale: props.i18n.locale,
      fonts: stripeFonts,
      appearance: stripeAppearance(),
    }}
  >
    <StripeInner {...props} />
  </Elements>

export default StripeOuter
